<template>
  <div :class="['bs-wizard-stepnum']">{{nome}}</div>
</template>

<script>
export default {
  name: "bs-wizard-stepnum",
  props: {
    nome: {
      default: "",
      type: String
    }
  }
};
</script>

<style>
.bs-wizard > .bs-wizard-step .bs-wizard-stepnum {
  color: #595959;
  font-size: 12px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/BsWizard/BsWizardStepnum.vue